// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"Input_inputContainer__1549k","icon":"Input_icon__3Px7t"};